import {
  CreateJobCatalogTreeDocument,
  CreateJobCatalogTreeMutation,
  JobCatalogTreePageDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const emptyTreeSerializedValue = `{ "attributes": [], "children": [] }`
const useCreateJobCatalogTree = () => {
  const [mutate, { loading }] = useMutation(CreateJobCatalogTreeDocument, {
    extractorFn: (data: CreateJobCatalogTreeMutation) =>
      data.jobCatalogMutations.createJobcatalogTree,
  })

  const createJobCatalogTree = (companyId: number, legalEntities: number[]) => {
    return mutate({
      variables: {
        companyId,
        legal_entities: legalEntities,
        serialized_tree: emptyTreeSerializedValue,
      },
      refetchQueries: [
        {
          query: JobCatalogTreePageDocument,
        },
      ],
    })
  }

  return { createJobCatalogTree, loading }
}

export default useCreateJobCatalogTree
